//----------------Data reducer types----------------
export const SET_COUNTRIESDATA = "SET_COUNTRIESDATA";
export const SET_COUNTRYDATA = "SET_COUNTRYDATA";

export const SET_GOVERNMENTSDATA = "SET_GOVERNMENTSDATA";
export const SET_GOVERNMENTDATA = "SET_GOVERNMENTDATA";
export const SET_SEARCH_GOVERNMENTSDATA = "SET_SEARCH_GOVERNMENTSDATA";
export const SUBMIT_GOVERNMENT_FEEDBACK = "SUBMIT_GOVERNMENT_FEEDBACK";
export const DELETE_GOVERNMENT_FEEDBACK = "DELETE_GOVERNMENT_FEEDBACK";

export const SET_POLITICALPARTIESDATA = "SET_POLITICALPARTIESDATA";
export const SET_POLITICALPARTYDATA = "SET_POLITICALPARTYDATA";
export const SET_SEARCH_POLITICALPARTIESDATA =
  "SET_SEARCH_POLITICALPARTIESDATA";
export const SUBMIT_PARTY_FEEDBACK = "SUBMIT_PARTY_FEEDBACK";
export const DELETE_POLITICALPARTY_FEEDBACK =
  "DELETE_POLITICALPARTIES_FEEDBACK";

export const SET_POLITICIANSDATA = "SET_POLITICIANSDATA";
export const SET_POLITICIANDATA = "SET_POLITICIANDATA";
export const SET_SEARCH_POLITICIANSDATA = "SET_SEARCH_POLITICIANSDATA";
export const SUBMIT_POLITICIAN_FEEDBACK = "SUBMIT_POLITICIAN_FEEDBACK";
export const DELETE_POLITICIAN_FEEDBACK = "DELETE_POLITICIAN_FEEDBACK";

//---------------------------------------COUNTRY SECTION-----------------------------------
export type CountriesApiRes = {
  countries: Array<IcountryData>;
};

export interface SetCountriesData {
  type: typeof SET_COUNTRIESDATA;
  payload: CountriesApiRes;
}
//For single country
export type CountryApiRes = {
  country: IcountryData;
};

export interface SetCountryData {
  type: typeof SET_COUNTRYDATA;
  payload: CountryApiRes;
}

//--------------------------------------GOVERNMENT SECTION----------------------------
export type GovernmentsApiRes = {
  governments: Array<IgovernmentData>;
};
export interface SetGovernmentsData {
  type: typeof SET_GOVERNMENTSDATA;
  payload: GovernmentsApiRes;
}
//For single government
export type GovernmentApiRes = {
  government: IgovernmentData;
};
export interface SetGovernmentData {
  type: typeof SET_GOVERNMENTDATA;
  payload: GovernmentApiRes;
}
// for gov search results
export type SearchGovernmentsApiRes = {
  governments: Array<IgovernmentData>;
};
export interface SetGovernmentsSearchData {
  type: typeof SET_SEARCH_GOVERNMENTSDATA;
  payload: SearchGovernmentsApiRes;
}
// for gov feedback
export type GovernmentFeedbackApiRes = {
  government: IgovernmentData;
};
export interface SetGovernmentFeedbackData {
  type: typeof SUBMIT_GOVERNMENT_FEEDBACK;
  payload: GovernmentFeedbackApiRes;
}
export interface DeleteGovermentFeedback {
  type: typeof DELETE_GOVERNMENT_FEEDBACK;
  payload: GovernmentFeedbackApiRes;
}
//--------------------------------------POLITICAL PARTY SECTION----------------------------
export type PoliticalPartiesApiRes = {
  politicalParties: Array<IpoliticalPartyData>;
};
export interface SetPoliticalPartiesData {
  type: typeof SET_POLITICALPARTIESDATA;
  payload: PoliticalPartiesApiRes;
}
//For single political party
export type PoliticalPartyApiRes = {
  politicalParty: IpoliticalPartyData;
};
export interface SetPoliticalPartyData {
  type: typeof SET_POLITICALPARTYDATA;
  payload: PoliticalPartyApiRes;
}
// for political party search results
export type SearchPoliticalPartiesApiRes = {
  politicalParties: Array<IpoliticalPartyData>;
};
export interface SetPoliticalPartiesSearchData {
  type: typeof SET_SEARCH_POLITICALPARTIESDATA;
  payload: SearchPoliticalPartiesApiRes;
}
// for political party feedbacks
export type PoliticalPartyFeedbackApiRes = {
  politicalParty: IpoliticalPartyData;
};
export interface SetPoliticalPartyFeedbackData {
  type: typeof SUBMIT_PARTY_FEEDBACK;
  payload: PoliticalPartyFeedbackApiRes;
}
export interface DeletePoliticalPartyFeedback {
  type: typeof DELETE_POLITICALPARTY_FEEDBACK;
  payload: PoliticalPartyFeedbackApiRes;
}
//-------------------------------------POLITICIAN SECTION---------------------------------
export type PoliticiansApiRes = {
  politicians: Array<IpoliticiansData>;
};

export interface SetPoliticiansData {
  type: typeof SET_POLITICIANSDATA;
  payload: PoliticiansApiRes;
}
//For single politician
export type PoliticianApiRes = {
  politician: IpoliticiansData;
};

export interface SetPoliticianData {
  type: typeof SET_POLITICIANDATA;
  payload: PoliticianApiRes;
}
// for politician feedbacks
export type PoliticianFeedbackApiRes = {
  politician: IpoliticiansData;
};

export interface SetPoliticianFeedbackData {
  type: typeof SUBMIT_POLITICIAN_FEEDBACK;
  payload: PoliticianFeedbackApiRes;
}
// For politicians search results
export type SearchPoliticiansApiRes = {
  politicians: Array<IpoliticiansData>;
};

export interface SetPoliticiansSearchData {
  type: typeof SET_SEARCH_POLITICIANSDATA;
  payload: SearchPoliticiansApiRes;
}
export interface DeletePoliticianFeedback {
  type: typeof DELETE_POLITICIAN_FEEDBACK;
  payload: PoliticianFeedbackApiRes;
}

export type DataDispatchTypes =
  | SetCountriesData
  | SetGovernmentsData
  | SetPoliticalPartiesData
  | SetPoliticiansData
  | SetCountryData
  | SetGovernmentData
  | SetPoliticalPartyData
  | SetPoliticianData
  | SetGovernmentsSearchData
  | SetPoliticalPartiesSearchData
  | SetPoliticiansSearchData
  | SetGovernmentFeedbackData
  | SetPoliticalPartyFeedbackData
  | SetPoliticianFeedbackData
  | DeleteGovermentFeedback
  | DeletePoliticalPartyFeedback
  | DeletePoliticianFeedback;
